// extracted by mini-css-extract-plugin
export default {"ContactElement":"ContactElement_ContactElement__C4MpJ"};